import PropTypes from "prop-types";

export const locationPropTypes = PropTypes.shape({
	hash: PropTypes.string.isRequired,
	key: PropTypes.string,
	pathname: PropTypes.string.isRequired,
	search: PropTypes.string.isRequired,
});

export const historyPropTypes = PropTypes.shape({
	push: PropTypes.func.isRequired,
	replace: PropTypes.func.isRequired,
	go: PropTypes.func.isRequired,
	goBack: PropTypes.func.isRequired,
	goForward: PropTypes.func.isRequired,
});



// WEBPACK FOOTER //
// ./src/shared/constants/propTypes.js